import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import NextLink from 'next/link';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx }, ref) => {
  const logo = (
    <Box ref={ref} sx={{ width: 66, height: 25, cursor: 'pointer', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 382 146">
        <g fillRule="evenodd" stroke="none" strokeWidth="1">
          <path 
            d="M0.425781 2.99999H66.6258C81.9591 2.99999 95.5591 5.86666 107.426 11.6C119.292 17.3333 128.492 25.4667 135.026 36C141.559 46.5333 144.826 58.8667 144.826 73C144.826 87.1333 141.559 99.4667 135.026 110C128.492 120.533 119.292 128.667 107.426 134.4C95.5591 140.133 81.9591 143 66.6258 143H0.425781V2.99999ZM65.0258 111.4C77.0258 111.4 86.6258 108 93.8258 101.2C101.159 94.4 104.826 85 104.826 73C104.826 61 101.159 51.6 93.8258 44.8C86.6258 38 77.0258 34.6 65.0258 34.6H40.0258V111.4H65.0258ZM165.66 2.99999H205.26V143H165.66V2.99999ZM304.034 145.8C289.234 145.8 275.9 142.667 264.034 136.4C252.3 130.133 243.034 121.467 236.234 110.4C229.567 99.3333 226.234 86.8667 226.234 73C226.234 59.1333 229.567 46.6667 236.234 35.6C243.034 24.5333 252.3 15.8667 264.034 9.59999C275.9 3.33332 289.234 0.199991 304.034 0.199991C318.834 0.199991 332.1 3.33332 343.834 9.59999C355.7 15.8667 364.967 24.5333 371.634 35.6C378.434 46.6667 381.834 59.1333 381.834 73C381.834 86.8667 378.434 99.3333 371.634 110.4C364.967 121.467 355.7 130.133 343.834 136.4C332.1 142.667 318.834 145.8 304.034 145.8ZM304.034 113C311.1 113 317.5 111.333 323.234 108C328.967 104.667 333.5 100 336.834 94C340.167 87.8667 341.834 80.8667 341.834 73C341.834 65.1333 340.167 58.2 336.834 52.2C333.5 46.0667 328.967 41.3333 323.234 38C317.5 34.6667 311.1 33 304.034 33C296.967 33 290.567 34.6667 284.834 38C279.1 41.3333 274.567 46.0667 271.234 52.2C267.9 58.2 266.234 65.1333 266.234 73C266.234 80.8667 267.9 87.8667 271.234 94C274.567 100 279.1 104.667 284.834 108C290.567 111.333 296.967 113 304.034 113Z"
            fill="black"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <NextLink href="/">{logo}</NextLink>;
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
